module.exports = __webpack_public_path__ + "media/images/team/william-ad7ff3e941f9f474fe9a0ec1c2ad177b.jpg";